import { Route } from "react-router-dom";

import {
  CREATE_CONTRACT,
  EDIT_CONTRACT,
  VIEW_SUBCONTRACTOR,
  VIEW_SUBCONTRACTOR_STATEMENT,
} from "src/constants";
import { SUBCONTRACTORS_ROUTES } from "src/pages/subcontractors/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditContract } from "./AddEditContract.page";
import { ContractDetails } from "./ContractDetails.page";
import { SingleSubcontractor } from "./SingleSubcontractor.page";
import { SubContractors } from "./SubContractors.page";
import { SubcontractorReceipt } from "./SubcontractorReceipt.page";

/** Route tree for the subcontractors module, mounted under `/subcontractors`, `/contracts` and `/subcontractor`. */
export const subcontractorsRoutes = (
  <>
    <Route
      path={SUBCONTRACTORS_ROUTES.root}
      element={<ProtectedRoute permissions={VIEW_SUBCONTRACTOR} component={SubContractors} />}
    />
    <Route
      path={SUBCONTRACTORS_ROUTES.addContract}
      element={<ProtectedRoute permissions={CREATE_CONTRACT} component={AddEditContract} />}
    />
    <Route
      path={SUBCONTRACTORS_ROUTES.editContract}
      element={<ProtectedRoute permissions={EDIT_CONTRACT} component={AddEditContract} />}
    />
    <Route
      path={SUBCONTRACTORS_ROUTES.details}
      element={<ProtectedRoute permissions={VIEW_SUBCONTRACTOR} component={SingleSubcontractor} />}
    />
    <Route
      path={SUBCONTRACTORS_ROUTES.payment}
      element={<ProtectedRoute permissions={VIEW_SUBCONTRACTOR_STATEMENT} component={SubcontractorReceipt} />}
    />
    <Route
      path={SUBCONTRACTORS_ROUTES.contract}
      element={<ProtectedRoute permissions={VIEW_SUBCONTRACTOR_STATEMENT} component={ContractDetails} />}
    />
  </>
);
